module.exports = __webpack_public_path__ + "img/blt-arrow05.da4d2fe1.svg";